import styled from 'styled-components'
import { Spinner } from '../Spinner'

const Pill = styled("div")`
	display: inline-flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	align-self: center;
	gap: 0.25rem;
	border-radius: 2rem;
	width: auto;
	height: 44px;
	min-height: 44px;
	max-height: 44px;
	min-width: 0;
	max-width: 100%;
	flex: 0 1 auto;
	margin: 0;
	padding: 0 0.7rem;
	background-color: #ffffff;
	color: var(--primaria-darkest);
	box-shadow: 0px 2px 7px 2px #00000033;
	white-space: nowrap;
	box-sizing: border-box;

	@media (max-width: 390px) {
		padding: 0 0.55rem;
		gap: 0.18rem;
	}

	@media (max-width: 360px) {
		height: 40px;
		min-height: 40px;
		max-height: 40px;
		padding: 0 0.48rem;
	}
`

const Text = styled.div`
	font-size: 0.72rem;
	line-height: 1;
	flex-shrink: 1;
	min-width: 0;
	margin: 0;
	padding: 0;

	@media (max-width: 390px) {
		font-size: 0.65rem;
	}

	/* Em telas bem estreitas, só o status (ONLINE/OFFLINE) */
	@media (max-width: 360px) {
		display: none;
	}
`

const Span = styled.div`
	color: ${props => props.cor};
	font-size: 0.82rem;
	font-weight: 700;
	line-height: 1;
	flex-shrink: 0;
	margin: 0;
	padding: 0;

	@media (max-width: 390px) {
		font-size: 0.76rem;
	}
`

const DivSpinner = styled.div`
	color: ${props => props.cor};
	display: inline-flex;
	align-items: center;
	justify-content: center;
	margin: 0;
	padding: 0;
`

export function AtivoPill({ texto, cor, compact = false }) {
	return (
		<Pill
			style={{ color: 'var(--primaria)' }}
			data-compact={compact ? 'true' : undefined}
			aria-label={texto ? `Você está ${texto}` : 'Status de conexão'}
		>
			{!compact && <Text>Você está</Text>}
			{texto === '' ? (
				<DivSpinner cor={cor}>
					<Spinner size="0.125rem" />
				</DivSpinner>
			) : (
				<Span cor={cor}>{texto}</Span>
			)}
		</Pill>
	)
}
